import { render, staticRenderFns } from "./EventEditLocation.vue?vue&type=template&id=050376d8&"
import script from "./EventEditLocation.vue?vue&type=script&lang=js&"
export * from "./EventEditLocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports